class ReferralHistory{

	constructor(customer){
		this.customer=customer;
	}
	renderReferralHistory() {
		$(".swell-referral-history-div").removeClass("hidden-form").addClass("showing-form");
		$(".swell-referral-details").addClass("swell-background-history");
		$(".swell-referral-history").append(
			$("<table>").addClass("swell-referral-history-table").append(
				$("<thead>").append(
					$("<tr>").append(
						$("<td>").text("Email"),
						$("<td>").text("Status"),
					)
				),
				$("<tbody>")
			)
		);

		this.populateReferredEmails();
	}

	populateReferredEmails() {
		this.customer.referrals.forEach(referrel => {
			$(".swell-referral-history table tbody").append(
				$("<tr>").append(
					$("<td>").text(referrel.email),
					$("<td>").text(`${referrel.completedAt === null ? "Invited" : "Purchased ($10 earned)"}`)
				)
			)
		})
	}
}

//renderReferralHistory()
// 	{	
// 		$(".swell-referral-history-div").removeClass("hidden-form").addClass("showing-form")
// 		$(".image").addClass("img-size-to-history")
// 		referrals.forEach(refer=>{
// 			$(".swell-referral-history table tbody").append(
// 				$("<tr>").append(
// 					$("<td>").text(refer.email),
// 					$("<td>").text(`${refer.completedAt!==null ? "Purchased" : "Invited"}`)))
// 		})
// 	}